import { render } from "./ForcePasswordResetModal.vue?vue&type=template&id=52d5bd4c&scoped=true"
import script from "./ForcePasswordResetModal.vue?vue&type=script&lang=js"
export * from "./ForcePasswordResetModal.vue?vue&type=script&lang=js"

import "./ForcePasswordResetModal.vue?vue&type=style&index=0&id=52d5bd4c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d5bd4c"]])

export default __exports__